import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'aff-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  @Output() closePopup = new EventEmitter<boolean>();
  @Output() clickBack = new EventEmitter<boolean>();
  @Input() title = '';

  @Input() backBtn: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  onClickBack(): void {
    this.clickBack.emit(true);
  }

  closePopupBox(value: boolean, e): void {
    // e.stopPropagation();
    if (e.target.className === 'popup_container' ||
        e.target.className === 'close') {
      this.closePopup.emit(value);
    }
  }
}
